import { Link } from "react-router-dom";
import { departments } from "@/mocks/updiag";

const deptImages = [
  "/img/readdy/z1.jpg",
  "/img/readdy/z2.jpg",
  "/img/readdy/z3.jpg",
  "/img/readdy/z4.jpg",
  "/img/readdy/z5.jpg",
  "/img/readdy/z6.jpg",
  "/img/readdy/z7.jpg",
  "/img/readdy/z8.jpg",
];

export default function ZonesSection() {
  return (
    <section className="bg-[#F8FAFC] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-blue-50 text-[#0F3B5F] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Zones d'intervention
          </span>
          <h2 className="text-4xl font-extrabold text-[#0F3B5F] mb-4" style={{ fontFamily: "Barlow, sans-serif" }}>
            Nous intervenons dans toute l'Île-de-France
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            8 départements couverts, RDV sous 48h partout en IDF.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {departments.map((dept, i) => (
            <Link
              key={dept.code}
              to={`/zones/${dept.slug}`}
              className="group relative rounded-2xl overflow-hidden h-48 cursor-pointer"
            >
              <img
                src={deptImages[i]}
                alt={`Diagnostic immobilier ${dept.name}`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F3B5F]/85 via-[#0F3B5F]/30 to-transparent"></div>
              <div className="absolute top-3 right-3 text-5xl font-extrabold text-white/20 leading-none" style={{ fontFamily: "Barlow, sans-serif" }}>
                {dept.code}
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="text-white font-bold text-base mb-1" style={{ fontFamily: "Barlow, sans-serif" }}>{dept.name}</div>
                <div className="flex flex-wrap gap-1">
                  {dept.villes.slice(0, 2).map((v) => (
                    <span key={v} className="text-white/70 text-[10px]">{v}</span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
